import script from "./BaseSpinner.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseSpinner.vue?vue&type=script&setup=true&lang=ts"

import "./BaseSpinner.vue?vue&type=style&index=0&id=5555b0e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.17_vue@3.5.17_webpack@5.99.9/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5555b0e8"]])

export default __exports__